/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default [
    {
        path: '/posts/type/:form_type_id',
        name: 'PostsByFormType',
        component: () => import("@/views/Post/PostsByFormType.vue"),
        meta: { permission: 'posts.view' }
    },
    {
        path: '/posts/:id',
        name: 'Post',
        component: () => import("@/views/Post/Post.vue"),
        meta: { permission: 'posts.view' }
    },
    {
        path: '/post/create/forms/:formId',
        name: 'CreatePost',
        component: () => import("@/views/Post/CreatePost.vue"),
        meta: { permission: 'posts.create' }
    },
    {
        path: '/posts',
        name: 'Data',
        component: () => import("@/views/Post/Posts.vue"),
        meta: { permission: 'posts.view' }
    },
    /*
     * Onglet « Contributions citoyennes » : même écran que la liste des
     * tickets, mais borné aux contributions par le filtre serveur
     * `filter[contribution]=1`. Une route à part (plutôt qu'une simple query)
     * pour que l'onglet et l'entrée de menu soient adressables et surlignés.
     */
    {
        path: '/contributions',
        name: 'Contributions',
        component: () => import("@/views/Post/Posts.vue"),
        meta: { permission: 'posts.view' }
    },
    {
        path: '/kanban',
        name: 'Kanban',
        component: () => import("@/views/Post/Kanban.vue"),
        meta: { permission: 'posts.view' }
    },
    {
        path: '/kanban/type/:form_type_id',
        name: 'KanbanByFormType',
        component: () => import("@/views/Post/Kanban.vue"),
        meta: { permission: 'posts.view' }
    },
    {
        path: '/map/type/:form_type_id',
        name: 'TicketMapByFormType',
        component: () => import("@/views/Post/TicketMap.vue"),
        meta: { permission: 'posts.view' }
    },
    {
        path: '/statistiques/type/:form_type_id',
        name: 'StatistiquesByFormType',
        component: () => import("@/views/Post/Statistiques.vue"),
        meta: { permission: 'company.statistics' }
    },
    {
        path: '/performances',
        name: 'Performances',
        component: () => import("@/views/Post/Performances.vue"),
        meta: { permission: 'company.statistics' }
    },
    {
        path: '/performances/type/:form_type_id',
        name: 'PerformancesByFormType',
        component: () => import("@/views/Post/Performances.vue"),
        meta: { permission: 'company.statistics' }
    },
    {
        path: '/post/create/forms',
        name: 'FormChoice',
        component: () => import("@/views/Post/FormChoice.vue"),
        meta: { permission: 'posts.create' }
    },
    {
        path: '/post/:postId/edit',
        name: 'EditPost',
        component: () => import("@/views/Post/EditPost.vue"),
        meta: { permission: 'posts.update' }
    },
    {
        path: '/map',
        name: 'TicketMap',
        component: () => import("@/views/Post/TicketMap.vue"),
        meta: { permission: 'posts.view' }
    },
    // Note: /map/type/:form_type_id is defined above as TicketMapByFormType
];
